import { render, staticRenderFns } from "./SalesmanCommodity.vue?vue&type=template&id=1b65bc0c&scoped=true"
import script from "./SalesmanCommodity.vue?vue&type=script&lang=js"
export * from "./SalesmanCommodity.vue?vue&type=script&lang=js"
import style0 from "./SalesmanCommodity.vue?vue&type=style&index=0&id=1b65bc0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b65bc0c",
  null
  
)

export default component.exports